// Utility to split and dedupe error/warning messages (from ActionView)
export function splitAndDedupeMessages(messages: string[] | undefined): string[] {
    if (!messages) return [];
    return Array.from(new Set(
        messages
            .filter(Boolean)
            .flatMap(msg => msg.split(';').map(s => s.trim()).filter(Boolean))
    ));
}
